"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const variants = {
  line: {
    tablist: {
      borderBottom: '2px solid',
      borderColor: 'inherit'
    },
    tab: {
      color: 'gray.600',
      borderBottom: '2px solid',
      borderColor: 'transparent',
      marginBottom: '-2px',
      _selected: {
        color: 'primary.default',
        borderColor: 'primary.default',
        fontWeight: 'semibold'
      },
      _active: {
        color: 'black',
        bg: 'transparent'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _hover: {
        color: 'black'
      }
    }
  },
  enclosed: {
    tablist: {
      backgroundColor: 'white',
      borderRadius: '8px',
      borederColor: 'gray.200',
      borderWidth: '1px',
      paddingY: 1
    },
    tab: {
      borderRadius: '6px',
      marginX: 1,
      _selected: {
        fontWeight: 'semibold',
        color: 'white',
        backgroundColor: 'primary.default',
        _hover: {
          backgroundColor: 'primary.600'
        }
      },
      _active: {
        backgroundColor: 'gray.200'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      }
    }
  }
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Tabs, {
  variants
});